import http from "./http";

export type PaymentCycleConfig = {
    cycle1EndDay: number;
    cycle2EmailDay: number;
    cycle1PayStart: number;
    cycle1PayEnd: number;
    cycle2PayStart: number;
    cycle2PayEnd: number;
    updatedAt?: string;
};

const DEFAULTS: PaymentCycleConfig = {
    cycle1EndDay: 15,
    cycle2EmailDay: 1,
    cycle1PayStart: 1,
    cycle1PayEnd: 5,
    cycle2PayStart: 16,
    cycle2PayEnd: 20,
};

export async function getPaymentCycleConfig(): Promise<PaymentCycleConfig> {
    const { data } = await http.get(`/utility/payment-cycle-config`);
    return { ...DEFAULTS, ...(data?.data || {}) };
}

export async function savePaymentCycleConfig(config: PaymentCycleConfig) {
    const { data } = await http.post(`/utility/payment-cycle-config`, config);
    return data;
}
